<div class="copo-datacenter-layout-title" translate>datacenter.drag-and-drop-item-hint</div>
<div class="copo-datacenter-layout-content">
	<div class="drag-container-wraper drag-container-right-border">
		<div class="drag-container">
			<h2 translate class="copo-datacenter-layout-content-header" id="fixed-columns">datacenter.fixed-columns</h2>
			<div
					cdkDropList
					#pinnedList="cdkDropList"
					[cdkDropListData]="columnAggregatorList.pinnedColumns"
					[cdkDropListConnectedTo]="[scrollableList, hidedList]"
					class="drag-list"
					role="list"
					aria-labelledby="fixed-columns"
					(cdkDropListDropped)="drop($event)">
				<div
						class="drag-box drag-box-small-margin"
						*ngFor="let item of columnAggregatorList.pinnedColumns; let i = index"
						#pinnedItem
						role="listitem"
						[attr.aria-labelledby]="`copo-pinned-column-${ i }`"
						tabindex="0"
						[attr.aria-grabbed]="isGrabbed('pinnedColumns', i)"
						(keydown)="onKeyDown($event, 'pinnedColumns', i)"
						(cdkDragStarted)="onDragStarted('pinnedColumns', i)"
						(cdkDragEnded)="onDragEnded()"
						cdkDrag>
					<mat-icon class="drag-icon small-icon-space-right" svgIcon="md:drag_indicator"></mat-icon>
					<span class="drag-box-added-label" [id]="`copo-pinned-column-${ i }`">{{item.header}}</span>
				</div>
			</div>
			<div class="hide-placeholder" *ngIf="columnAggregatorList.pinnedColumns.length === 0">
				<mat-icon svgIcon="md:drag_indicator"></mat-icon>
				<p translate>datacenter.drag-element-here-fixed</p>
			</div>
		</div>
	</div>
	<div class="drag-container-wraper drag-container-right-border">
		<div class="drag-container">
			<h2 translate class="copo-datacenter-layout-content-header" id="scrollable-columns">datacenter.scrollable-columns</h2>
			<div
					cdkDropList
					#scrollableList="cdkDropList"
					[cdkDropListData]="columnAggregatorList.scrollableColumns"
					[cdkDropListConnectedTo]="[pinnedList, hidedList]"
					class="drag-list"
					role="list"
					aria-labelledby="scrollable-columns"
					(cdkDropListDropped)="drop($event)">
				<div
						class="drag-box drag-box-bigger-margin"
						*ngFor="let item of columnAggregatorList.scrollableColumns; let i = index"
						#scrollableItem
						role="listitem"
						[attr.aria-labelledby]="`copo-scrollable-column-${ i }`"
						tabindex="0"
						[attr.aria-grabbed]="isGrabbed('scrollableColumns', i)"
						(keydown)="onKeyDown($event, 'scrollableColumns', i)"
						(cdkDragStarted)="onDragStarted('scrollableColumns', i)"
						(cdkDragEnded)="onDragEnded()"
						cdkDrag>
					<mat-icon class="drag-icon small-icon-space-right" svgIcon="md:drag_indicator"></mat-icon>
					<span class="drag-box-added-label" [id]="`copo-scrollable-column-${ i }`">{{item.header}}</span>
				</div>
			</div>
			<div class="hide-placeholder" *ngIf="columnAggregatorList.scrollableColumns.length === 0">
				<mat-icon svgIcon="md:drag_indicator"></mat-icon>
				<p translate>datacenter.drag-element-here-scrollable</p>
			</div>
		</div>
	</div>
	<div class="add-sort-container center">
		<div class="drag-container-header">
			<mat-icon class="drag-icon small-icon-space-right" svgIcon="md:drag_indicator"></mat-icon>
			<copo-slide-button labelAfter="datacenter.sorting"
								labelBefore="datacenter.add-columns"
								(toggleChange)="onToggleChange()"
								[checked]="togglePosition"
								id="current-layout-toggle-sort-add"
								>
			</copo-slide-button>
			<mat-icon class="chevron-icon-disactivated" svgIcon="sorting_icon"></mat-icon>
		</div>
		<div class="drag-container">
			<mat-form-field class="column-search" appearance="outline" subscriptSizing="dynamic">
				<mat-icon svgIcon="search" class="column-search-icon" matPrefix></mat-icon>
				<input
						[placeholder]="'search.placeholder' | translate"
						matInput
						type="text"
						spellcheck="false"
						autocomplete="off"
						[formControl]="searchTextControl"/>
				<button type="button" *ngIf="searchTextControl.value" matSuffix mat-icon-button
						(click)="searchTextControl.reset('');" tabindex="-1">
					<mat-icon svgIcon="md:close"></mat-icon>
				</button>
			</mat-form-field>
			<div
					cdkDropList
					#hidedList="cdkDropList"
					[cdkDropListData]="columnAggregatorList.allColumns"
					[cdkDropListConnectedTo]="[pinnedList, scrollableList]"
					class="drag-list drag-list-add"
					role="list"
					aria-labelledby="current-layout-toggle-sort-add"
					(cdkDropListDropped)="drop($event)">
				<div
						class="drag-box drag-box-bigger-margin"
						*ngFor="let item of columnAggregatorList.allColumns; let i = index"
						#allItem
						role="listitem"
						[attr.aria-labelledby]="`copo-all-column-${ i }`"
						tabindex="0"
						[attr.aria-grabbed]="isGrabbed('allColumns', i)"
						(keydown)="onKeyDown($event, 'allColumns', i)"
						(cdkDragStarted)="onDragStarted('allColumns', i)"
						(cdkDragEnded)="onDragEnded()"
						cdkDrag>
					<mat-icon class="drag-icon small-icon-space-right" svgIcon="md:drag_indicator"></mat-icon>
					<span class="drag-box-added-label" [id]="`copo-all-column-${ i }`">{{item.header}}</span>
				</div>
				<div class="hide-placeholder" *ngIf="columnAggregatorList.allColumns.length === 0">
					<mat-icon svgIcon="md:drag_indicator"></mat-icon>
					<p translate>datacenter.all-columns-added-to-grid</p>
					<p translate>datacenter.drag-element-here-hide</p>
				</div>
			</div>
		</div>
	</div>
</div>